var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import moment from 'moment';
import eventBus from '../../utils/fresh-table';
import colorSelect from './color-select.vue';
import searchInput from '../../components/console-common/search-input.vue';
export default Vue.extend({
    components: {
        'el-select-color': colorSelect,
        'el-search-input': searchInput,
    },
    created: function () {
        this.searchForm = Object.assign({}, this.searchForm, this.defaultSearch); // 赋初始值 比如radio有默认选中项
    },
    mounted: function () {
        eventBus.$on('freshTable', this.filter);
        this.filter();
    },
    data: function () {
        return {
            searchForm: {},
            pageNo: 1,
            pageSize: 20,
            // searchKey: '',
            // searchUrl: '',
            resultData: '',
            pickerOptions: {},
        };
    },
    props: {
        defaultSearch: {
            type: Object,
            default: function () {
                return {};
            },
        },
        searchConfig: {
            type: Array,
            default: function () {
                return [];
            },
        },
        requestConfig: {
            type: Object,
        },
        exportConfig: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    methods: {
        changeKey: function (val) {
            this.searchForm.selectedKey = val;
        },
        clearDate: function (val) {
            var _this = this;
            this.searchConfig.forEach(function (item) {
                if (item.type === 'selectDate') {
                    var val_1 = _this.searchForm[item.dateKey];
                    if (typeof val_1 === 'object' && val_1 instanceof Array) {
                        _this.searchForm[item.dateKey] = [];
                    }
                }
            });
        },
        reset: function () {
            this.searchForm = Object.assign({}, this.defaultSearch);
            this.requestConfig.params = Object.assign({}, { pageSize: 20, pageNo: 1 });
            this.filter();
        },
        filterBefore: function () {
            this.requestConfig.params = Object.assign({}, { pageSize: 20, pageNo: 1 });
            this.filter();
        },
        filter: function (otherParam) {
            // 来自slot的查询条件
            if (otherParam === void 0) { otherParam = {}; }
            var param = this.searchForm; // 默认提取查询模块的查询条件
            var params = __assign({}, param, otherParam);
            this.searchConfig.forEach(function (item) {
                if (item.type === 'inputSearch') {
                    params[params[item.key]] = params[item.key + "_input"] || '';
                    delete params[item.key];
                    delete params[item.key + "_input"];
                }
                if (item.type === 'date') {
                    var start = params[item.startTimeKey];
                    var end = params[item.endTimeKey];
                    params[item.startTimeKey] = start
                        ? moment(start).format('YYYY-MM-DD')
                        : '';
                    params[item.endTimeKey] = end ? moment(end).format('YYYY-MM-DD') : '';
                }
                if (item.type === 'selectDate') {
                    var dateType = params.dateType;
                    var selectDate = params[item.dateKey];
                    if (selectDate &&
                        typeof selectDate === 'object' &&
                        selectDate.length > 0) {
                        var _a = item['dateTypes'][dateType], start = _a[0], end = _a[1];
                        params[start] = selectDate[0];
                        params[end] = selectDate[1];
                    }
                    delete params[item.dateKey];
                    delete params.dateType;
                }
                if (item.type === 'noSelectdateRange') {
                    var dateKeys = item.dateKeys;
                    var key = item.key;
                    if (params[key] && params[key].length) {
                        params[dateKeys[0]] = params[key][0];
                        params[dateKeys[1]] = params[key][1];
                    }
                    delete params[key];
                }
                // if(item.type === 'searchSelectInput') {
                //   console.log(params)
                //   console.log(item)
                //   const key = params.selectedKey
                //   item.option.forEach((val) => {
                //     console.log(val)
                //     if(params.selectedKey === val.val) {
                //       params[key] = params[item.key]
                //     }
                //   })
                //   this.searchKey = item.searchKey[key]
                //   this.searchUrl = item.searchUrl
                //   const name = item.storeData
                //   console.log(item.storeData)
                //   // this.resultData = name
                //   // this.resultData = [item.storeData]
                //   console.log(this.resultData)
                //   delete params.selectedKey
                //   delete params.nameMobile
                //   delete params.searchKey
                //   delete params.searchUrl
                //   delete params.storeData
                //   console.log(params)
                //   // console.log(item)
                // }
            });
            var requestParams = Object.assign({}, params, this.requestConfig.params);
            this.$store.dispatch(this.requestConfig.storeName, __assign({}, requestParams));
        },
        requestExport: function () {
            // 导出函数
            // const params = this.exportConfig.params // 目前暂时不需要
            var url = this.exportConfig.url
                ? this.exportConfig.url
                : this.requestConfig.url;
            this.$request({
                url: this.exportConfig.url,
                method: 'post',
                data: __assign({}, this.searchPara),
            }).then(function (res) {
                if (!res.errorCode) {
                    window.open(res.data.downloadurl);
                }
            });
        },
    },
    watch: {
        otherParam: function () {
            // update list
            this.filter(this.otherParam);
        },
    },
});
